import { functions, httpsCallable } from "./firebaseConfig";

const getWorkEquipmentCatalog = httpsCallable(functions, "getWorkEquipmentCatalog");
const lookupWorkImdb = httpsCallable(functions, "lookupWorkImdb");
const createWorkVideoUpload = httpsCallable(functions, "createWorkVideoUpload");
const getWorkVideoUploadStatus = httpsCallable(functions, "getWorkVideoUploadStatus");
const cleanupWorkMuxUploadCallable = httpsCallable(functions, "cleanupWorkMuxUpload");
const publishWorkMarkdown = httpsCallable(functions, "publishWorkMarkdown");
const listWorkEntries = httpsCallable(functions, "listWorkEntries");
const getWorkEntry = httpsCallable(functions, "getWorkEntry");
const saveWorkDraftCallable = httpsCallable(functions, "saveWorkDraft");
const listWorkDraftsCallable = httpsCallable(functions, "listWorkDrafts");
const getWorkDraftCallable = httpsCallable(functions, "getWorkDraft");
const deleteWorkDraftCallable = httpsCallable(functions, "deleteWorkDraft");

function unwrap(result) {
  const payload = result?.data || {};
  if (payload.success === false) {
    throw new Error(payload.message || "Request failed.");
  }
  return payload.data ?? payload;
}

export async function fetchWorkEquipmentCatalog() {
  return unwrap(await getWorkEquipmentCatalog({}));
}

export async function lookupWorkImdbRating(imdbLink) {
  return unwrap(await lookupWorkImdb({ imdbLink }));
}

export async function createWorkMuxUpload({ corsOrigin, slug, title, category }) {
  return unwrap(await createWorkVideoUpload({
    corsOrigin,
    slug,
    title,
    category,
  }));
}

export async function pollWorkMuxUpload(uploadId) {
  return unwrap(await getWorkVideoUploadStatus({ uploadId }));
}

export async function cleanupWorkMuxUpload({ uploadId = "", assetId = "" } = {}) {
  return unwrap(await cleanupWorkMuxUploadCallable({ uploadId, assetId }));
}

export async function publishWorkPage(payload) {
  return unwrap(await publishWorkMarkdown(payload));
}

export async function fetchWorkEntries() {
  return unwrap(await listWorkEntries({}));
}

export async function fetchWorkEntry(slug) {
  return unwrap(await getWorkEntry({ slug }));
}

export async function saveWorkDraft(payload) {
  return unwrap(await saveWorkDraftCallable(payload));
}

export async function fetchWorkDrafts() {
  return unwrap(await listWorkDraftsCallable({}));
}

export async function fetchWorkDraft(id) {
  return unwrap(await getWorkDraftCallable({ id }));
}

export async function deleteWorkDraft({ id, keepVideo = false }) {
  return unwrap(await deleteWorkDraftCallable({ id, keepVideo }));
}

export function uploadFileToMux(uploadUrl, file, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", uploadUrl);
    xhr.setRequestHeader("Content-Type", file.type || "application/octet-stream");
    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable || typeof onProgress !== "function") return;
      onProgress(Math.round((event.loaded / event.total) * 100));
    };
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
        return;
      }
      reject(new Error(`Mux upload failed (${xhr.status}).`));
    };
    xhr.onerror = () => reject(new Error("Mux upload failed."));
    xhr.send(file);
  });
}
